import Router from 'next/router';
import _ from 'lodash';

import constructSlug from './construct-slug';

// **BUSINESS LOGIC**
// Check a vehicle's UCSR rating and if it is less than 5, return a new vehicle object with a ucsrSaferPick of false
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'vehicle' implicitly has an 'any' type.
const checkUcsrSaferPick = (vehicle) => {
  const { ucsrRating } = vehicle;
  const ucsrSaferPick = ucsrRating < 5 ? false : (vehicle.ucsrSaferPick ?? false);
  return { ...vehicle, ucsrSaferPick };
};

const navigateToVehiclePage = async (
  make: string,
  model: string,
  year?: string,
  vehicle?: string,
  shouldReplace = false
) => {
  let url = `/[make]`;
  let asPath = `/${constructSlug(make)}`;

  if (!_.isUndefined(model)) {
    url = `${url}/[model]`;
    asPath = `${asPath}/${constructSlug(model)}`;
  }

  if (!_.isUndefined(year)) {
    url = `${url}/[year]`;
    asPath = `${asPath}/${year}`;
  }

  if (!_.isUndefined(vehicle)) {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ pathname: string; query: { vehicle: any; }; }' is not assignable to type 'string'.
    url = {
      pathname: url,
      query: { vehicle },
    };
    asPath = `${asPath}?vehicle=${vehicle}`;
  }

  Router[shouldReplace ? 'replace' : 'push'](url, asPath);
};

export { navigateToVehiclePage, checkUcsrSaferPick };
